const protocol = self.location.protocol;
export const baseUrl = `${protocol}//www.hqccglobal.com/api`;